import { Spinner } from "reactstrap";

export function Loading(
    {
        className
    }:{
        className?: string
    }
) {
    const cName = className ?? "";
    return <div className={[cName, 'd-flex flex-fill justify-content-center align-items-center'].join(' ')}>
        <Spinner/>
    </div>
}
